export default __webpack_public_path__ + "static/media/sales-funnel-temporary.215493a5.jpg";